function getView() {
  let DictCtxView = {
    model: "melhous.message",
    form_action: ["edit", "add", "save"],
    table_action: ["edit", "add", "delete"],
    activeSearch: false,
    target: "melhous",
    autoSave: true,
    domain: [],
    fields: {
      title: { type: "char", required: true },
      body: { type: "text" },
      kind: {
        type: "selection",
        options: [
          { id: "info", name: "info" },
          { id: "promo", name: "promo" },
          { id: "alert", name: "alert" },
        ],
        translate: true,
        required: true,
      },
      start: { type: "datetime", formatString: "YYYY-MM-DD HH:mm" },
      end: { type: "datetime", formatString: "YYYY-MM-DD HH:mm" },
      active: { type: "boolean" },
    },
    list: [{ name: "title" }, { name: "kind" }, { name: "active" }],
    form: [
      { name: "title" },
      { name: "kind" },
      { name: "start" },
      { name: "end" },
      { name: "active" },
      { name: "body", colSpan: "md:col-span-2" },
    ],
  };

  return DictCtxView;
}

export default { ctxView: getView };
